var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "attendance-img-wrapper" } }, [
    _c(
      "div",
      { staticClass: "attendance-wrapper" },
      _vm._l(7, function (i) {
        return _c(
          "div",
          { key: i, staticClass: "attendance_wrap", class: { seven: i === 7 } },
          [
            i === 7
              ? _c("div", { staticClass: "title" }, [_vm._v("7day")])
              : _vm._e(),
            _c("img", { attrs: { src: _vm.attendanceImgUrl(i) } }),
          ]
        )
      }),
      0
    ),
    _vm.isMobile ? _c("div", { staticClass: "apt-img" }) : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }